import { Component, EventEmitter, Inject, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ActionBtn } from 'src/app/interfaces/action-btn.model';
import { AlertInputFormControl } from 'src/app/interfaces/alert-form-control.model';

@Component({
  selector: 'app-dialog-form-box',
  templateUrl: './dialog-form-box.component.html',
  styleUrls: ['./dialog-form-box.component.scss']
})
export class DialogFormBoxComponent implements OnInit {
  @Input() title: string;
  @Input() msg: string;
  @Input() actionBtns: ActionBtn[] = [];
  @Input() formInputs: AlertInputFormControl[] = [];
  @Output() closeModal: EventEmitter<any> = new EventEmitter<any>();
  @Output() emitFormValues: EventEmitter<any> = new EventEmitter<any>();
  @Input() processing: boolean = false;
  @Input() errMsg: string;
  msgBoxForm: FormGroup;
  constructor(public dialogRef: MatDialogRef<DialogFormBoxComponent>,
      @Inject(MAT_DIALOG_DATA) public data: any) { 
        this.title = data['title'];
        this.msg = data['msg'];
        this.actionBtns = data['actionBtns'];
        this.formInputs = data['formInputs'] || [];
        this.processing = data['processing'];
        this.errMsg = data['errMsg'];
      }

  ngOnInit() {
    this.initForm();
  }
  initForm() {
    const group: { [key: string]: FormControl } = {};
    this.formInputs.forEach(input => {
      group[input.name] = new FormControl('');
    });
    this.msgBoxForm = new FormGroup(group);
  }

  closeDialog() {
    this.closeModal.emit()
  }

  submitForm() {
    this.processing = true;
    const formValue = this.msgBoxForm.value;   
    this.emitFormValues.emit({type: 'submit', formValue})
  }

}
